
/// <amd-module name="TFS/Admin/Common/Constants/DataProviderConstants" />
export namespace DataProviders {
    export const InitPermissionsView = "InitializePermissionView";
    export const TenantId = "/TenantId";
    export const OrganizationRestClient = "Organization-AdminArea.IOrganizationRestClient";
    export const Me = "Me";
    export const OwnerPath = "/Owner";
    export const TimeZonePath = "/SystemProperty.TimeZone";
    export const DescriptionPath = "/SystemProperty.Description";
    export const PrivacyUrlPath = "/SystemProperty.PrivacyUrl";
    export const NamePath = "/Name";
    export const InitGroupsView = "InitializeGroupsView";
    export const FetchPermissionsGroups = "FetchPermissionsGroups";
    export const SetDefaultTeam = "SetDefaultTeam";
    export const CreateTeam = "CreateTeam";
    export const SetTeamAdmins = "SetTeamAdmins";
    export const RemoveTeamAdmin = "RemoveTeamAdmin";
    export const SetAreaPath = "SetAreaPath";
}
